import { render } from "./homeslide5.vue?vue&type=template&id=a2ebc704&scoped=true"
import script from "./homeslide5.vue?vue&type=script&lang=js"
export * from "./homeslide5.vue?vue&type=script&lang=js"

import "./homeslide5.vue?vue&type=style&index=0&id=a2ebc704&lang=less&scoped=true"

import exportComponent from "/Users/zhoubenhao/Desktop/行云/numatch/numatch-home/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2ebc704"]])

export default __exports__